<section *ngIf="currentMessage && buyPolicyFormSubmitted" class="py-5">
  <div class="text-center img-block mt-5">
    <img src="assets/images/products/TravelInsurance.png" alt="" loading="lazy">
  </div>
  <div class="text-center">
    <h4>{{ currentMessage }}</h4>
  </div>
</section>

<section *ngIf="!currentMessage && !buyPolicyFormSubmitted && underwritingDetails.length>0" class="container py-5">
  <div class="back-button mb-4">
    <span class="back-icon" (click)="goBack()"><i class="fa-solid fa-arrow-left"></i></span>
    <h4 class="back-button-heading mx-3">Underwriting</h4>
  </div>

  <div class="card rounded-0 mb-2">
    <div class="card-body d-md-flex justify-content-between px-4 py-3">
      <div><strong>Quotation Number :</strong> {{quotationInfo?.QuotationNumber}}</div>
      <div><strong>Product Name :</strong> {{selectedProduct?.ProductName}}</div>
      <div><strong>Premium Amount : </strong> <strong class="text-primary">{{selectedProduct?.sTotalAmount}}</strong>
      </div>
    </div>
  </div>
  <div class="card rounded-0">
    <div class="card-body ">
      <div class="row">
        <div class="nav flex-column nav-pills col-md-4" id="v-pills-tab" role="tablist" aria-orientation="vertical">
          <div class="stage-item"
            *ngFor="let underwritingDetail of underwritingDetails; let i = index; let isFirst = first; let isLast = last">
            <button [ngClass]="{'active': activeIndex === underwritingDetail.id}"
              [disabled]="(underwritingDetail.id === '6' && isDisablePayment)" class="nav-link"
              (click)="changeActiveIndex(underwritingDetail.id)" id="v-pills-{{underwritingDetail.id}}-tab"
              data-bs-toggle="pill" [attr.data-bs-target]="'#v-pills-' + underwritingDetail.id" type="button" role="tab"
              [attr.aria-controls]="'v-pills-' + underwritingDetail.id" aria-selected="true">
              <i class="fa-solid fa-circle-check"
                [ngClass]="(underwritingDetail.id === '6' && isDisablePayment) ? 'icon-default' : 'icon-success'"></i>
              {{underwritingDetail.title}}
            </button>
            <div *ngIf="!isLast" class="py-3 stage-status"
              [ngClass]="(underwritingDetail.id === '5' && isDisablePayment) ? 'border-assign-default' : 'border-assign-success'">
            </div>
          </div>
        </div>

        <div class="tab-content col-md-8" id="v-pills-tabContent">
          <div class="tab-pane fade" id="v-pills-1"
            [ngClass]="{'show active': activeIndex === '1', 'fade': activeIndex !== '1'}" role="tabpanel"
            aria-labelledby="v-pills-1-tab" tabindex="0">
            <div class="heading2 mb-4">Quote Information</div>
            <section>
              <form [formGroup]="quotationFieldsForm">
                <div class="mb-4">
                  <label class="field-label d-block mb-3">Travel Purpose </label>
                  <div class="btn-group" role="group" aria-label="Travel Purpose">
                    <ng-container *ngFor="let travelPurpose of getTravelPurposeList">
                      <input type="radio" class="btn-check" [id]="travelPurpose.masterDataID"
                        [value]="travelPurpose.masterDataID" formControlName="travelPurpose">
                      <label class="btn rounded radio-outline-button me-2 px-2 px-md-5 py-2"
                        [for]="travelPurpose.masterDataID">{{travelPurpose?.mdTitle}}</label>
                    </ng-container>
                  </div>
                </div>
                <div class="mb-2">
                  <label class="field-label">Destination(s) </label>
                  <div class="">
                    <mat-form-field class="example-chip-list w-100">
                      <mat-chip-grid #chipGrid1 aria-label="Destination selection" formControlName="destination">
                        <mat-chip-row *ngFor="let destination of selectedDestinations" (removed)="remove(destination)">
                          {{destination.ToCountryName}}
                          <button matChipRemove [attr.aria-label]="'remove ' + destination.ToCountryName">
                            <mat-icon>cancel</mat-icon>
                          </button>
                        </mat-chip-row>
                      </mat-chip-grid>

                      <input #destinationInput1 (focus)="onFocus()" [matChipInputFor]="chipGrid1"
                        [matAutocomplete]="auto" />
                      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                        <mat-option *ngFor="let destination of filteredDestinations | async"
                          [value]="destination.TocountryID">
                          {{destination.ToCountryName}}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="field-label">Trip Start Date </label>
                    <mat-form-field class="w-100">
                      <input matInput [matDatepicker]="tripStartDate" [min]="minTripStartDate"
                        formControlName="tripStartDate" placeholder="DD/MM/YYYY">
                      <mat-datepicker-toggle matIconSuffix [for]="tripStartDate"></mat-datepicker-toggle>
                      <mat-datepicker #tripStartDate></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="field-label">Trip End Date </label>
                    <mat-form-field class="w-100">
                      <input matInput [matDatepicker]="tripEndDate" [min]="minTripEndDate" formControlName="tripEndDate"
                        placeholder="DD/MM/YYYY">
                      <mat-datepicker-toggle matIconSuffix [for]="tripEndDate"></mat-datepicker-toggle>
                      <mat-datepicker #tripEndDate></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div class="mb-2">
                  <label class="field-label">Traveling Days </label>
                  <mat-form-field class="w-100 mat-form-field-sm">
                    <input matInput type="text" (input)="numberOnly($event)" formControlName="travelingDays">
                  </mat-form-field>
                </div>
                <div class="mb-2">
                  <label class="field-label">Number of Travelers </label>
                  <mat-form-field class="w-100 mat-form-field-sm">
                    <input matInput type="text" formControlName="numberOfTravelers" maxlength="1"
                      (keypress)="numberOnly($event)" (blur)="numberOfTravelers()">
                  </mat-form-field>
                </div>
              </form>
            </section>
          </div>

          <div *ngIf="!isBulkUpload" class="tab-pane fade" id="v-pills-2"
            [ngClass]="{'show active': activeIndex === '2', 'fade': activeIndex !== '2'}" role="tabpanel"
            aria-labelledby="v-pills-2-tab" tabindex="0">
            <div class="heading2 mb-4">Proposal Form</div>
            <section>
              <form [formGroup]="proposalForm">
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="field-label">Product Name </label>
                    <mat-form-field class="w-100 mat-form-field-sm">
                      <input matInput type="text" formControlName="productName">
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="field-label">Premium Amount </label>
                    <mat-form-field class="w-100 mat-form-field-sm">
                      <input matInput type="text" formControlName="premiumAmount">
                    </mat-form-field>
                  </div>
                </div>
                <div class="mb-2">
                  <label class="field-label">Destination(s) </label>
                  <div class="">
                    <mat-form-field class="example-chip-list w-100">
                      <mat-chip-grid #chipGrid aria-label="Destination selection" formControlName="destination">
                        <mat-chip-row *ngFor="let destination of selectedDestinations" (removed)="remove(destination)">
                          {{destination.ToCountryName}}
                          <button matChipRemove [attr.aria-label]="'remove ' + destination.ToCountryName">
                            <mat-icon>cancel</mat-icon>
                          </button>
                        </mat-chip-row>
                      </mat-chip-grid>

                      <input #destinationInput (focus)="onFocus()" [matChipInputFor]="chipGrid"
                        [matAutocomplete]="auto" />
                      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                        <mat-option *ngFor="let destination of filteredDestinations | async"
                          [value]="destination.TocountryID">
                          {{destination.ToCountryName}}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="field-label">Trip Start Date </label>
                    <mat-form-field class="w-100">
                      <input matInput [matDatepicker]="tripStartDate1" formControlName="tripStartDate"
                        placeholder="DD/MM/YYYY">
                      <mat-datepicker-toggle matIconSuffix [for]="tripStartDate1"></mat-datepicker-toggle>
                      <mat-datepicker #tripStartDate1></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="field-label">Trip End Date </label>
                    <mat-form-field class="w-100">
                      <input matInput [matDatepicker]="tripEndDate1" [min]="minTripEndDate"
                        formControlName="tripEndDate" placeholder="DD/MM/YYYY">
                      <mat-datepicker-toggle matIconSuffix [for]="tripEndDate1"></mat-datepicker-toggle>
                      <mat-datepicker #tripEndDate1></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="field-label">Traveling Days </label>
                    <mat-form-field class="w-100 mat-form-field-sm">
                      <input matInput type="text" (keypress)="numberOnly($event)" formControlName="travelingDays">
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="field-label">Number of Travelers </label>
                    <mat-form-field class="w-100 mat-form-field-sm">
                      <input matInput type="text" formControlName="numberOfTravelers" (keypress)="numberOnly($event)"
                        (blur)="numberOfTravelers()">
                    </mat-form-field>
                  </div>
                </div>
                <div class="mb-2">
                  <label class="field-label">KRA Pin Type</label>
                  <div>
                    <mat-radio-group formControlName="kraPinType">
                      <mat-radio-button *ngFor="let kRAPintype of kRAPintypeList" [value]="kRAPintype.masterDataID">
                        {{ kRAPintype.mdTitle }}
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="field-label">KRA Pin Number</label>
                    <mat-form-field class="w-100 mat-form-field-sm">
                      <input matInput type="text" formControlName="kraPinNumber">
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="field-label">Insured's Occupation</label>
                    <mat-form-field class="w-100 mat-form-field-sm">
                      <input matInput type="text" formControlName="insuredOccupation">
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="field-label">Beneficiary Name</label>
                    <mat-form-field class="w-100 mat-form-field-sm">
                      <input matInput type="text" formControlName="beneficiaryName">
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="field-label">Beneficiary Mobile Number</label>
                    <mat-form-field class="w-100 mat-form-field-sm">
                      <input matInput (keypress)="numberOnly($event)" type="text"
                        formControlName="beneficiaryTelephoneNo">
                    </mat-form-field>
                  </div>
                </div>
                <section formGroupName="address">
                  <div class="heading2 mt-4 mb-2">Postal Address</div>
                  <div class="mb-2">
                    <label class="field-label">House Number </label>
                    <mat-form-field class="w-100 mat-form-field-sm">
                      <input matInput type="text" formControlName="houseNumber">
                    </mat-form-field>
                  </div>
                  <div class="mb-2">
                    <label class="field-label">Road Name </label>
                    <mat-form-field class="w-100 mat-form-field-sm">
                      <input matInput type="text" formControlName="roadName">
                    </mat-form-field>
                  </div>
                  <div class="mb-2">
                    <label class="field-label">Pincode </label>
                    <mat-form-field class="w-100 mat-form-field-sm">
                      <input matInput type="text" formControlName="pincode" (keypress)="numberOnly($event)">
                    </mat-form-field>
                  </div>
                </section>
              </form>
            </section>
          </div>

          <div *ngIf="!isBulkUpload" class="tab-pane fade" id="v-pills-3"
            [ngClass]="{'show active': activeIndex === '3', 'fade': activeIndex !== '3'}" role="tabpanel"
            aria-labelledby="v-pills-3-tab" tabindex="0">
            <section class="mt-4">
              <form [formGroup]="travelersForm">
                <section class="mt-4" formArrayName="travelersDetails">
                  <div class="heading1 mb-4">Travelers Information</div>
                  <div *ngFor="let travelerDetail of getTravelersDetails.controls; let i = index" [formGroupName]="i"
                    class="mb-4">
                    <div class="heading2">
                      Traveler {{i + 1}}
                      <section class="example-section d-inline">
                        <mat-checkbox formControlName="isProposerATraveller">Is the Proposer?</mat-checkbox>
                      </section>
                    </div>
                    <div class="row">
                      <div class="col-md-6 mb-2">
                        <label class="field-label">First Name </label>
                        <mat-form-field class="w-100 mat-form-field-sm">
                          <input matInput type="text" formControlName="firstName">
                        </mat-form-field>
                      </div>
                      <div class="col-md-6 mb-2">
                        <label class="field-label">Last Name </label>
                        <mat-form-field class="w-100 mat-form-field-sm">
                          <input matInput type="text" formControlName="lastName">
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 mb-2">
                        <label class="field-label">Name as per the passport </label>
                        <mat-form-field class="w-100 mat-form-field-sm">
                          <input matInput type="text" formControlName="nameAsPerThePassport">
                        </mat-form-field>
                      </div>
                      <div class="col-md-6 mb-2">
                        <label class="field-label">Email ID</label>
                        <mat-form-field class="w-100 mat-form-field-sm">
                          <input matInput type="text" formControlName="emailId">
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 mb-2">
                        <label class="field-label">Date of Birth</label>
                        <mat-form-field class="w-100">
                          <input matInput [matDatepicker]="picker" [max]="dateOfBirthMaxDate"
                            formControlName="dateOfBirth" placeholder="DD/MM/YYYY"
                            (dateChange)="dateOfBirthChange($event, i)">
                          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker="matDatepicker"></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div class="col-md-6 mb-2">
                        <label class="field-label">Age</label>
                        <mat-form-field class="w-100 mat-form-field-sm">
                          <input matInput (keypress)="numberOnly($event)" type="text" formControlName="age">
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4 mb-2">
                        <label class="field-label">Country Code</label>
                        <mat-form-field class="w-100">
                          <mat-select formControlName="mobileCode">
                            <mat-option *ngFor="let code of countryCodes" [value]="code.masterDataID">
                              <span> {{code.mdTitle}}</span>
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-8 mb-2">
                        <label class="field-label">Mobile Number</label>
                        <mat-form-field class="w-100 mat-form-field-sm">
                          <input matInput (keypress)="numberOnly($event)" type="text" formControlName="mobileNumber">
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 mb-2">
                        <label class="field-label">Passport Number</label>
                        <mat-form-field class="w-100 mat-form-field-sm">
                          <input matInput type="text" formControlName="passportNumber">
                        </mat-form-field>
                      </div>
                      <div class="col-md-6 mb-2">
                        <label class="field-label">Relationship with the proposer</label>
                        <mat-form-field class="w-100">
                          <mat-select formControlName="relationshipWithTheProposer">
                            <mat-option *ngFor="let relationship of relationshipList"
                              [value]="relationship.masterDataID">
                              {{relationship.mdTitle}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="mb-2"
                      *ngIf="travelerDetail.get('passportFileAttachmentID')?.value!='00000000-0000-0000-0000-000000000000'">
                      <div><a class="link" (click)="DownloadPassportCopy(i)">Download Passport <i
                            class="fa-solid fa-download"></i></a> </div>
                    </div>
                  </div>
                </section>
              </form>
            </section>
          </div>
          <div class="tab-pane fade" id="v-pills-4"
            [ngClass]="{'show active': activeIndex === '4', 'fade': activeIndex !== '4'}" role="tabpanel"
            aria-labelledby="v-pills-4-tab" tabindex="0">
            <div class="heading2 mb-4">Coverages</div>
            <p>The following coverages are included in this product:</p>
            <div>
              <div class="table-responsive table-block">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th class="fixed-column-1 fixed-column--index-2">Coverages</th>
                      <th class="fixed-column-2 fixed-column--index-2">Cover Limits</th>
                      <th *ngFor="let product of productDetails" class="text-center">
                        {{ product.ProductName }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let coverage of coveragesList">
                      <tr
                        *ngFor="let data of (coverage.additionalData.length ? coverage.additionalData : [{}]); let i = index">
                        <ng-container *ngIf="i === 0">
                          <td [attr.rowspan]="coverage.additionalData.length || 1" class="fixed-column-1">{{
                            coverage.CoverageName }}</td>
                        </ng-container>
                        <td *ngIf="data.AdditionalCoverageLabel" class="fixed-column-2">{{
                          data.AdditionalCoverageLabel }}</td>
                        <td *ngIf="!data.AdditionalCoverageLabel" class="text-center fixed-column-2">-</td>
                        <td *ngFor="let product of productDetails" class="text-center">
                          <ng-container
                            *ngIf="product.coverageQuotesCompare[coverage.CoverageID] && product.coverageQuotesCompare[coverage.CoverageID][data.AdditionalCoverageID]; else noData">
                            <div class="text-center text-success">
                              <i class="fa-solid fa-check"></i>
                            </div>
                            <div>
                              {{
                              product.coverageQuotesCompare[coverage.CoverageID][data.AdditionalCoverageID]
                              }}
                            </div>
                          </ng-container>
                          <ng-template #noData>
                            <div class="text-center text-red">
                              <i class="fa-solid fa-xmark"></i>
                            </div>
                          </ng-template>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="v-pills-5"
            [ngClass]="{'show active': activeIndex === '5', 'fade': activeIndex !== '5'}" role="tabpanel"
            aria-labelledby="v-pills-5-tab" tabindex="0">
            <div class="heading2 mb-4 text-center">Branch Selection (Optional)</div>
            <p>If you are issuing this policy on behalf of a different branch, you can select the branch from the
              options below.</p>
            <div>
              <form [formGroup]="branchForm">
                <div class="mb-2">
                  <label class="field-label">Choose Branch</label>
                  <mat-form-field class="example-full-width w-100">
                    <input type="text" matInput formControlName="branch" [matAutocomplete]="autoBranch">
                    <mat-autocomplete #autoBranch="matAutocomplete" [displayWith]="branchDisplayFn">
                      <mat-option *ngFor="let option of branchFilteredOptions | async" [value]="option">
                        {{option.orgGroupName}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <!-- <div class="text-red small"
                          *ngIf="branchSubmitted && branchForm.get('branch')?.invalid && branchForm.get('branch')?.errors?.['required']">
                          Branch is required.
                        </div> -->
                </div>
                <div class="text-center mt-5">
                  <button class="button1" (click)="BranchUpdate()">Next</button>
                </div>
              </form>
            </div>
          </div>
          <div class="tab-pane fade" id="v-pills-6"
            [ngClass]="{'show active': activeIndex === '6', 'fade': activeIndex !== '6'}" role="tabpanel"
            aria-labelledby="v-pills-6-tab" tabindex="0">
            <div class="heading2 mb-4">Payment Methods</div>
            <section>
              <form [formGroup]="paymentMethodsForm">
                <div class="form-check" *ngFor="let paymentMethod of paymentMethods">
                  <div>
                    <input class="form-check-input" type="radio" [id]="paymentMethod.masterDataID"
                      [value]="paymentMethod.masterDataID" formControlName="paymentMode">
                    <label class="form-check-label" [for]="paymentMethod.masterDataID">
                      {{paymentMethod.mdTitle}}
                    </label>
                  </div>
                </div>
                <div *ngIf="paymentMethodsForm.get('paymentMode')?.value=='93ca7eec-e630-48ff-b3b4-352939a2648d'" class="mt-3">
                  <label class="field-label">Enter Reference Number <span class="text-red small">*</span></label>
                  <mat-form-field class="w-100 mat-form-field-sm">
                    <input matInput type="text" formControlName="quotationReferenceNumber">
                  </mat-form-field>
                  <div class="text-red small"
                    *ngIf="submitted && paymentMethodsForm.get('quotationReferenceNumber')?.invalid && paymentMethodsForm.get('quotationReferenceNumber')?.errors?.['required']">
                    Reference Number is required.
                  </div>
                </div>
                <div class="text-red small"
                  *ngIf="submitted && paymentMethodsForm.get('paymentMode')?.invalid && paymentMethodsForm.get('paymentMode')?.errors?.['required']">
                  Select the Payment Method.
                </div>
                <div class="text-center mt-5">
                  <button class="button1" (click)="buyPolicySubmit()">Buy Policy</button>
                </div>
              </form>
            </section>
          </div>

          <div *ngIf="isBulkUpload" class="tab-pane fade" id="v-pills-7"
          [ngClass]="{'show active': activeIndex === '7', 'fade': activeIndex !== '7'}" role="tabpanel"
          aria-labelledby="v-pills-7-tab" tabindex="0">
          <div class="heading2 mb-4">Travelers Information</div>
          <section class="table-responsive" *ngIf="userProposalBulkList.length>0">
            <table class="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">First Name</th>
                    <th scope="col">Last Name</th>
                    <th scope="col">Name as per the passport</th>
                    <th scope="col">Email ID</th>
                    <th scope="col">Date of Birth</th>
                    <th scope="col">Age</th>
                    <th scope="col">Relationship with the proposer</th>
                    <th scope="col">Is the Proposer?</th>
                    <th scope="col">Mobile Number</th>
                    <th scope="col">Passport Number</th>
                    <th scope="col">KRA Pin Type</th>
                    <th scope="col">KRA Pin Number</th>
                    <th scope="col">Insured's Occupation</th>
                    <th scope="col">House Number</th>
                    <th scope="col">Road Name</th>
                    <th scope="col">Pincode</th>
                    <th scope="col">Beneficiary Name</th>
                    <th scope="col">Beneficiary Mobile Number </th>
                    <th scope="col">Status</th>
                    <th scope="col">Message</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let userProposal of userProposalBulkList; let i = index">
                    <tr>
                      <td scope="row">{{userProposal.fIRSTNAME}}</td>
                      <td scope="row">{{userProposal.lASTNAME}}</td>
                      <td scope="row">{{userProposal.fULLNAME}}</td>
                      <td scope="row">{{userProposal.eMAILID}}</td>
                      <td scope="row">{{userProposal.dATEOFBIRTH | date: 'dd/MM/yyyy' }}</td>
                      <td scope="row">{{userProposal.aGE}}</td>
                      <td scope="row">{{userProposal.rELATIONSHIPWITHTHEPROPOSER}}</td>
                      <td scope="row">{{userProposal.iSTHEPROPOSER}}</td>
                      <td scope="row">{{userProposal.mOBILENO}}</td>
                      <td scope="row">{{userProposal.pASSPORTNUMBER}}</td>
                      <td scope="row">{{userProposal.kRAPINTYPE}}</td>
                      <td scope="row">{{userProposal.kRAPINNUMBER}}</td>
                      <td scope="row">{{userProposal.iNSUREDOCCUPATION}}</td>
                      <td scope="row">{{userProposal.hOUSENUMBER}}</td>
                      <td scope="row">{{userProposal.rOADNAME}}</td>
                      <td scope="row">{{userProposal.pINCODE}}</td>
                      <td scope="row">{{userProposal.bENEFICIARYNAME}}</td>
                      <td scope="row">{{userProposal.bENEFICIARYMOBILENUMBER}}</td>
                      <td scope="row">
                        <div [ngClass]="{'text-success': !userProposal.iSERROR, 'text-danger': userProposal.iSERROR}">
                          {{ userProposal.iSERROR ? 'Rejected' : 'Approved' }}
                        </div>
                      </td>
                      
                      <td scope="row">
                        <div *ngFor="let errorMessage of userProposal.eRRORMESSAGE">
                            {{errorMessage.Value}}
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
        </section>
        </div>
        </div>
      </div>
    </div>

  </div>
</section>